import moment from "moment";
import feathers from "@feathersjs/feathers";
import feathersRestClient from "@feathersjs/rest-client";
import axios from "axios";
import Config from "../config";
import swal from "sweetalert2";
import Feathers from "../redux/FeathersRedux";
import { laravelService } from "./laravelService";

export const checkHasIncidence = async (pedido_id, rodillo_id) => {
  return await Feathers.service("incidencia")
    .find({
      query: {
        pedido_id,
        rodillo_id,
        solucion: null,
      },
    })
    .then((res) => {
      if (res.data.length) {
        return true;
      } else {
        return false;
      }
    });
};

export const checkInventory = async (
  rawMaterials,
  userId,
  pedido_id,
  rodillo_id,
  PHASE
) => {
  const idMaterials = rawMaterials
    ? rawMaterials.map((rawMaterial) => rawMaterial.materia_prima_id)
    : [];

  let hasIncidence = await checkHasIncidence(pedido_id, rodillo_id);

  await laravelService
    .get(`inventory/rawMaterialInventroy?clave_id=${idMaterials}`)
    .then(async (res) => {
      const rawMaterialInventory = res.data.filter(
        (rawMaterial) => rawMaterial.is_below_min === 1
      );

      if (rawMaterialInventory.length && !hasIncidence) {
        hasIncidence = await createIncidenceInventory(
          rawMaterialInventory,
          userId,
          rodillo_id,
          pedido_id,
          PHASE
        );
      }
    });

  return hasIncidence;
};

export const createIncidenceInventory = async (
  rawMaterialInventory,
  userId,
  rodilloId,
  pedidoId,
  PHASE
) => {
  const incidenceTypeId = 24;

  const neededRawMaterials = rawMaterialInventory.map(
    (rawMaterial) => rawMaterial.nombre
  );

  const textRawMaterials = neededRawMaterials.join(", ");

  const description = `No hay suficiente inventario de las materias primas. ${textRawMaterials}`;
  let newDataToSend = new FormData();
  newDataToSend.set("tipo_incidencia_id", incidenceTypeId);
  newDataToSend.set("descripcion", description);
  newDataToSend.set("fecha_hora", moment().format("YYYY-MM-DD HH:mm:ss"));
  newDataToSend.set("usuario_id", userId);
  newDataToSend.set("rodillo_id", rodilloId);
  newDataToSend.set("pedido_id", pedidoId);
  newDataToSend.set("etapa", PHASE);

  const token = await localStorage.getItem("bingham-jwt");
  const app = feathers();
  const restClient = feathersRestClient(Config.apiUrl);
  app.configure(restClient.axios(axios));

  let hasIncidence = false;

  await app
    .service("incidencia")
    .create(newDataToSend, {
      headers: {
        Authorization: token,
        "Content-Type": "multipart/form-data",
      },
    })
    .then(async (res) => {
      await Feathers.service("revision")
        .create({
          rodillo_id: rodilloId,
          pedido_id: pedidoId,
          incidencia_id: res.id,
        })
        .then(async (res) => {
          await swal({
            title: "No hay inventario suficiente para esta tarea",
            text: "Se ha creado una incidencia de inventario insuficiente.",
            type: "warning",
            confirmButtonText: "OK",
          });
          hasIncidence = true;
        })
        .catch((err) => {
          console.log(err, "error revision");
        });
    })
    .catch((err) => {
      console.log(err, "error incidencia");
    });
  return hasIncidence;
};
